<template>
    <el-container style="height: 650px">
        <el-header style="line-height: 60px; padding: 0px">
            <el-row type="flex" :gutter="20" justify="start">
                <el-col>
                    <el-button style="margin-right: 10px" class="btn-primary" size="small" v-if="permission.del" @click="delEntpApplyCheckFlows">{{ permission.del }}</el-button>
                    <el-cascader
                        style="margin-right: 10px"
                        v-model="searchData.orgId"
                        :options="orgTree"
                        :props="singleProps"
                        filterable
                        clearable
                        @change="onOrgSelectChange"
                    ></el-cascader>
                    <el-select style="margin-right: 10px; height: 100%" v-model="staffIds" filterable multiple clearable collapse-tags @change="onStaffSelectChange">
                        <el-option v-for="item in entpStaffsList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <el-select style="margin-right: 10px" v-model="searchData.typeId" filterable clearable>
                        <el-option v-for="item in entpApplyTypesList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <el-input style="width: 300px; margin-right: 10px" v-model="searchData.name" placeholder="输入流程名称查找"></el-input>
                    <el-button class="btn-primary" size="small" @click="GetEntpApplyCheckFlowsList">搜索</el-button>
                </el-col>
            </el-row>
        </el-header>
        <el-container style="height: 100%">
            <el-main width="100%" height="100%" style="padding: 0px; margin: 0px">
                <el-table @selection-change="handleSelectionChange" :header-cell-style="{ background: '#F2F6FC' }" :data="entpApplyCheckFlowList" border style="width: 100%" fit>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column min-width="300px" prop="TypeName" label="流程类型"></el-table-column>
                    <el-table-column min-width="250px" prop="FlowName" label="流程名称"></el-table-column>
                    <el-table-column min-width="250px" prop="User" label="使用人">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showDetialDialog(scope, 0)">
                                <span>{{ scope.row.User == null ? '-' : scope.row.User }}</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="250px" prop="ApproverCount" label="审批人">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showDetialDialog(scope, 1)">
                                <span>{{ scope.row.ApproverCount == null ? '-' : scope.row.ApproverCount + '人' }}</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="250px" prop="NotifiersCount" label="通知人">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showDetialDialog(scope, 2)">
                                <span>{{ scope.row.NotifiersCount == null ? '-' : scope.row.NotifiersCount + '人' }}</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button v-if="permission.edit" type="text" size="mini" @click="routeToEditFlow(scope)">{{ permission.edit }}</el-button>
                                <el-button v-if="permission.del" type="text" size="mini" @click="delEntpApplyCheckFlows(scope)">{{ permission.del }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount"
                ></el-pagination>
            </div>
            <el-dialog :title="dialogName" :visible.sync="detialDialog" width="30%">
                <template>
                    <span :key="index" v-for="(item, index) in flowObjsList">
                        <el-tag class="flowobjsTag">
                            <span v-if="dialogName == '审批人'">第{{ index + 1 }}审批人:</span>
                            {{ item.Name }}
                        </el-tag>
                    </span>
                </template>
            </el-dialog>
        </el-container>
    </el-container>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: { elTableColumn },
    data() {
        return {
            dialogName: '',
            entpId: this.$util.getLocalStorage('userMsg').EntpId,
            permission: this.$util.getPermission('Approval'),
            detialDialog: false,
            ids: '',
            dataCount: 0,
            entpApplyTypesSearchData: {
                entpId: '',
                name: '',
                page: 1,
                limit: 1000
            },
            staffIds: [],
            entpApplyTypesList: [],
            searchData: {
                entpId: '',
                typeId: '',
                name: '',
                orgId: '',
                staffIds: '',
                page: 1,
                limit: 15
            },
            entpApplyCheckFlowList: [],
            entpStaffsSearchData: {
                entpId: '',
                cascadeId: '',
                name: ''
            },
            flowObjsSearchData: {
                entpId: '',
                flowId: '',
                objType: ''
            },
            flowObjsList: [],
            entpStaffsList: [], //企业员工列表
            orgTree: [],
            flowUserForOrgList: [], //部门
            singleProps: {
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true,
                emitPath: false,
                expandTrigger: 'hover'
            }
        };
    },
    created() {
        this.entpApplyTypesSearchData.entpId = this.entpId;
        this.searchData.entpId = this.entpId;
        this.entpStaffsSearchData.entpId = this.entpId;
        this.flowObjsSearchData.entpId = this.entpId;
        this.GetEntpApplyCheckFlowsList();
        this.getEntpApplyTypesList();
        this.getSubOrgTree();
        this.getEntpStaffsSelectList();
    },
    mounted() {},
    methods: {
        onOrgSelectChange(val) {
            if (this.searchData.orgId == 0) {
                this.searchData.orgId = '';
            }
            this.staffIds = '';
        },
        onStaffSelectChange(val) {
            this.searchData.orgId = '';
        },
        showDetialDialog(scope, type) {
            if (scope.row) {
                this.flowObjsSearchData.flowId = scope.row.Id;
                this.flowObjsSearchData.objType = type;
                switch (type) {
                    case 1:
                        this.dialogName = '审批人';
                        break;
                    case 2:
                        this.dialogName = '通知人';
                        break;
                    case 0:
                        this.dialogName = '使用人';
                        break;
                }
                this.getFlowObjs();
            }
        },
        routeToEditFlow(scope) {
            this.$emit('setTab', 'approvalEdit', scope.row.Id);
        },
        //获取流程列表
        GetEntpApplyCheckFlowsList() {
            this.searchData.staffIds = this.staffIds.toString();
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpApplyCheckFlowsList',
                    data: this.searchData
                })
                .then(res => {
                    this.entpApplyCheckFlowList = [];
                    if (res.data) {
                        this.dataCount = res.count;
                        this.entpApplyCheckFlowList = res.data;
                    }
                })
                .catch(err => {});
        },
        //获取流程使用者
        getFlowObjs() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetFlowObjs',
                    data: this.flowObjsSearchData
                })
                .then(res => {
                    if (res.data) {
                        this.flowObjsList = res.data;
                        this.detialDialog = true;
                    }
                })
                .catch(err => {});
        },
        //获取假期类型
        getEntpApplyTypesList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpApplyTypesList',
                    data: this.entpApplyTypesSearchData
                })
                .then(res => {
                    if (res.data) {
                        this.entpApplyTypesList = res.data;
                    }
                })
                .catch(err => {});
        },
        //获取组织结构
        getSubOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetSubOrgTree',
                    data: { entpId: this.entpId }
                })
                .then(res => {
                    if (res.data) {
                        if (res.data[0].Id == null) {
                            res.data[0].Id = '1';
                        }
                        this.orgTree = this.getTreeData(res.data);
                    }
                })
                .catch(err => {});
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        //获取企业员工
        getEntpStaffsSelectList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpStaffsSelectList',
                    data: this.entpStaffsSearchData
                })
                .then(res => {
                    if (res.data) {
                        this.entpStaffsList = res.data;
                    }
                })
                .catch(err => {});
        },
        delEntpApplyCheckFlows(scope) {
            let ids = '';
            if (scope.row) {
                ids = scope.row.Id;
            } else {
                ids = this.ids;
            }

            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/DelEntpApplyCheckFlows?ids=' + ids
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('删除成功');
                        this.GetEntpApplyCheckFlowsList();
                    }
                })
                .catch(err => {});
        },
        //多选
        handleSelectionChange(val) {
            this.ids = '';
            val.forEach(element => {
                this.ids += element.Id + ',';
            });
            this.ids = this.ids.slice(0, this.ids.length - 1);
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.GetEntpApplyCheckFlowsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.GetEntpApplyCheckFlowsList();
        }
    }
};
</script>
<style lang="less" scoped>
.flowobjsTag {
    margin: 10px;
}
</style>
